<template>
    <form class="form-horizontal group-border-dashed" @submit.prevent="handleSubmit" novalidate>
        <div class="form-group">
            <h3 class="wizard-title text-uppercase">Situationsanalyse – Prozesse</h3>
        </div>

        <check-question
            name="content"
            title="Wie oft erstellen Sie redaktionell Inhalte?"
            subtitle="Gemeint ist wie oft Sie bewusst Inhalte (Fotos, Texte etc.) für ihre Online Kanäle aufbereiten / lassen."
            :notes.sync="formData.content_notes"
            :disabled="disabled"
        >
            <select-menu slot="input" :options="contentOptions" :disabled="disabled" v-model="formData.content" :validation="$v.formData.content"/>
        </check-question>

        <check-question
            name="channels"
            title="Auf welchen Kanälen distribuieren Sie diese Inhalte?"
            subtitle="Wählen Sie alle Kanäle aus, welchen Sie min. einmal pro Jahr mit Informationen updaten."
            :notes.sync="formData.channels_notes"
            :disabled="disabled"
        >
            <multi-select
                slot="input"
                optionsKey="channels"
                subject="Channel erfassen"
                :disabled="disabled"
                v-model="formData.channels"
                :validation="$v.formData.channels"
            />
        </check-question>

        <check-question
            name="strongestChannel"
            title="Welches ist prozentual ihr umsatzstärkster Kanal?"
            subtitle="Um die Vergleichbarkeit sicherzustellen, bitten wir Sie jeweils einen prozentualen Schätzwert des Umsatzes der letzten 12 Monate anzugeben."
            :notes.sync="formData.strongestChannel_notes"
            :disabled="disabled"
        >
            <div slot="input">
                <range-slider name="strongestChannel" label="Umsatzstärkste Kanäle" :min="0" :max="100" :connect="[true,true,true,true]" :disabled="disabled" :formatter="() => ''" v-model="strongestChannel"/>
                <ul>
                    <li>Direkt Online (Eigene Webseite, E-Mail): <strong>{{ formData.strongestChannel_onlineDirect }}%</strong></li>
                    <li>Direkt Offline (Telefon, Walk-In's): <strong>{{ formData.strongestChannel_offlineDirect }}%</strong></li>
                    <li>Indirekt Online (Vermittler Portal, bspw. OTA): <strong>{{ formData.strongestChannel_onlineIndirect }}%</strong></li>
                    <li>Indirekt Offline (Agenten, Telefon, Brief): <strong>{{ formData.strongestChannel_offlineIndirect }}%</strong></li>
                </ul>
            </div>
        </check-question>

        <check-question
            name="budget"
            title="Wie gross ist ihr jährliches Marketingbudget und wie viel Prozent investieren Sie in Online-Medien?"
            subtitle="Um die Vergleichbarkeit sicherzustellen, bitten wir Sie jeweils einen prozentualen Schätzwert des Umsatzes der letzten 12 Monate anzugeben."
            :notes.sync="formData.budget_notes"
            :disabled="disabled"
        >
            <div slot="input">
                <text-field label="Marketingbudget: in CHF" :disabled="disabled" v-model="formData.budget" :validation="$v.formData.budget"/>
                <range-slider name="budget_online" label="davon Online: in Prozent %" :min="0" :max="100" :disabled="disabled" :formatter="value => `${value}%`" v-model="formData.budget_online"/>
            </div>
        </check-question>

        <check-question
            name="monitoring"
            title="Messen und kennen Sie wichtigsten Kennzahlen ihrer Online-Kanäle?"
            subtitle="Wählen Sie alle Tools aus, welche Sie für die Erfolgsmessung einsetzen."
            :notes.sync="formData.monitoring_notes"
            :disabled="disabled"
        >
            <multi-select
                slot="input"
                optionsKey="monitoring"
                subject="Monitoring erfassen"
                :disabled="disabled"
                v-model="formData.monitoring"
                :validation="$v.formData.monitoring"/>
        </check-question>

        <div class="form-group" v-if="!disabled">
            <button class="btn btn-lg btn-secondary btn-space" type="button" @click.prevent="$emit('previous', formData)">zurück</button>
            <button class="btn btn-lg btn-success btn-space wizard-next" type="submit" v-if="lastStep">Digital.Check abschliessen</button>
            <button class="btn btn-lg btn-primary btn-space wizard-next" type="submit" v-else>weiter</button>
        </div>
    </form>
</template>

<script>
    import { required, numeric } from 'vuelidate/lib/validators';

    import exam from '../../../mixins/exam';

    import CheckQuestion from './Question';

    export default {
        mixins: [exam],
        components: { CheckQuestion },

        data: () => ({
            formData: {
                content: '',
                content_notes: '',
                channels: [],
                channels_notes: '',
                strongestChannel_onlineDirect: 25,
                strongestChannel_onlineIndirect: 25,
                strongestChannel_offlineDirect: 25,
                strongestChannel_offlineIndirect: 25,
                strongestChannel_notes: '',
                budget: '',
                budget_online: 0,
                budget_notes: '',
                monitoring: [],
                monitoring_notes: '',
            },

            contentOptions: [
                { value: '', label: 'Bitte wählen …' },
                { value: '1Day', label: '1 pro Tag' },
                { value: 'xWeek', label: 'mehrmals pro Woche' },
                { value: '1Week', label: '1 pro Woche' },
                { value: '2Week', label: 'alle 2 Wochen' },
                { value: '1Month', label: 'monatlich' },
                { value: '3Month', label: 'quartalsweise' },
                { value: '6Month', label: 'halbjährlich' },
                { value: '12Month', label: 'jährlich' },
            ],

            strongestChannel: [25, 50, 75],
        }),

        validations: {
            formData: {
                content: { required },
                channels: { required },
                budget: { required, numeric },
                monitoring: { required },
            },
        },

        watch: {
            strongestChannel(value) {
                this.formData.strongestChannel_onlineDirect = value[0];
                this.formData.strongestChannel_offlineDirect = value[1] - value[0];
                this.formData.strongestChannel_onlineIndirect = value[2] - value[1];
                this.formData.strongestChannel_offlineIndirect = 100 - value[2];
            },
        },
    };
</script>
